var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item position-relative"},[_c('a',{staticClass:"nav-link",attrs:{"href":_vm.url('wishlist')}},[_vm._v("\n        "+_vm._s(_vm.t.wishlist.wishlist)+" "),_c('i',{staticClass:"fa-solid fa-heart"}),_vm._v(" "),_c('span',{staticClass:"badge rounded-pill border bg-light text-dark"},[_vm._v(_vm._s(this.wishlist.length))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }